<template>
  <div class="typing-text" :style="`width: ${width}; height: ${height}`">
    {{content}}
    <div class="caret"></div>
  </div>
</template>

<script>
export default {
  name: "TypingText",
  props: {
    width: {
      type: Number,
      default: 300
    },
    height: {
      type: Number,
      default: 200
    },
    fontSize: {
      type: Number,
      default: 14
    },
    text: {
      type: String,
      default: ""
    }
  },
  watch: {
    text: function(newVal, oldVal) {
      console.log("new", newVal);
      console.log("old", oldVal);
      this.start();
    }
  },
  data() {
    return {
      content: "",
      interval: undefined,
      current: 0
    };
  },
  methods: {
    start() {
      // 初始化
      this.content = "";
      clearInterval(this.interval);
      this.current = 0;

      // 定时器
      this.$emit("changeForegroundMusic", "/music/打字.mp3", true);
      this.interval = setInterval(this.play, 200);

      this.$emit("start");
    },
    play() {
      if (this.current >= this.text.length) {
        this.$emit("changeForegroundMusic", "/music/打字.mp3", false);
        clearInterval(this.interval);
        this.end();
      } else {
        this.current = this.current + 1;
        this.content = this.text.slice(0, this.current);
      }
    },
    end() {
      this.$emit("end");
    }
  }
};
</script>

<style lang="scss" scoped>
.typing-text {
  overflow: hidden;

  .caret {
    display: inline-block;
    width: 2px;
    height: 14px;
    background: #333;
    // margin: 0 6px;

    vertical-align: middle;

    animation: blink-caret 0.5s step-end infinite;
  }

  @keyframes blink-caret {
    50% {
      opacity: 0;
    }
  }
}
</style>